module.exports = __webpack_public_path__ + "img/pgn04.718eab35.png";